import { yupResolver } from '@hookform/resolvers/yup';
import { FC } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { RoomMoveReportFormModel } from '../../models';
import { FilterForm } from './FilterForm';
import { schema } from './schema';

export const FilterFormProvider: FC<{
  defaultValues: RoomMoveReportFormModel;
  onSubmit: (data: RoomMoveReportFormModel) => void;
}> = ({ defaultValues, onSubmit }) => {
  const form = useForm<RoomMoveReportFormModel>({
    mode: 'onSubmit',
    reValidateMode: 'onChange',
    resolver: yupResolver(schema),
    defaultValues: defaultValues,
  });

  return (
    <FormProvider {...form}>
      <FilterForm onSubmit={onSubmit} onReset={() => form.reset(defaultValues)} />
    </FormProvider>
  );
};
